import { useSearchParams } from "react-router-dom";

import { isJamaLang, JamaLang } from "config/i18n/jamaLangs";
import useLang from "hooks/useLang";

/** Language of the JAMA page content: ?lang=<code> (any of the 23
 *  judojama.com languages, set by the language menu), else the site language. */
const useJamaLang = (): JamaLang => {
  const siteLang = useLang();
  const [params] = useSearchParams();
  const param = params.get("lang");
  return isJamaLang(param) ? param : siteLang;
};

export default useJamaLang;
